import { useQuery } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getEmployeeDetails } from 'services/employee';

const getData = async ({ employeeId }) => {
  try {
    const emp = await getEmployeeDetails(employeeId);
    return emp;
  } catch (err) {
    console.error('Error fetching employee : ', err);
    throw err;
  }
};

export const useProfilePage = ({ employeeId }) =>
  useQuery([REACT_QUERY_KEYS.profileData, employeeId], () => getData({ employeeId }), {
    enabled: Boolean(employeeId),
    onError: (error) => error,
  });
